import {
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
  ModalFooter,
  Button,
  Text,
  ListItem,
  UnorderedList,
  VStack,
  Heading,
  Box,
} from "@chakra-ui/react";
import { ModalBody } from "./Styles";
import useScreenType from "react-screentype-hook";
import { IgniteChakraModal } from "./IgniteChakraModal";

const CookiePolicyModal = ({ isOpen, onClose }) => {
  const { isMobile } = useScreenType();

  return (
    <IgniteChakraModal
      size={isMobile ? "full" : "xl"}
      onClose={onClose}
      isOpen={isOpen}
      scrollBehavior={"inside"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Measure Ignite – Cookie Policy</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>Last Updated: Nov 26, 2025</Text>
          
          <VStack spacing={6} align="start">
            <Text>
              Measure Ignite uses cookies and similar technologies to improve your experience on our platform. 
              This Cookie Policy explains what cookies are, how we use them, and the choices you have. 
              At Measure we strive to be transparent about your data.
            </Text>

            <Box>
              <Heading as="h2" size="md" mb={2}>1. What Are Cookies?</Heading>
              <Text>
                Cookies are small text files stored on your device when you visit a website or use a web platform. 
                They help the site remember your actions and preferences so you don't have to re-enter them each time.
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" mb={2}>2. How We Use Cookies</Heading>
              <Text mb={2}>Measure Ignite uses cookies to:</Text>
              <UnorderedList spacing={2} pl={5}>
                <ListItem>Enable essential platform functions (e.g., logging in, maintaining secure sessions)</ListItem>
                <ListItem>Improve performance and reliability (e.g., tracking errors, loading speed)</ListItem>
                <ListItem>Understand how the platform is used (e.g., analytics to help us enhance features and user experience)</ListItem>
                <ListItem>Remember your preferences (e.g., language settings, saved filters)</ListItem>
              </UnorderedList>
              <Text mt={2}>
                We adhere to strict ethical data standards. We do not use cookies to collect sensitive personal information, 
                nor do we sell your data to third parties.
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" mb={2}>3. Types of Cookies We Use</Heading>
              <Text fontWeight="bold" mb={1}>Essential Cookies</Text>
              <Text mb={3}>Required for the platform to work properly. You cannot disable these through the platform.</Text>
              
              <Text fontWeight="bold" mb={1}>Analytics Cookies</Text>
              <Text mb={3}>Help us understand how users navigate and interact with Ignite so we can improve functionality and content.</Text>
              
              <Text fontWeight="bold" mb={1}>Preference Cookies</Text>
              <Text>Store your user settings to personalize your experience.</Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" mb={2}>4. Third-Party Cookies</Heading>
              <Text>
                We may use trusted third-party tools (Sentry, Google Analytics) that set their own cookies. 
                These partners only use the information to help us analyze platform performance and usage.
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" mb={2}>5. Cookie Controls</Heading>
              <Text>
                You can manage or delete cookies through your browser settings. Note that disabling certain cookies 
                may affect your ability to use some features of the Ignite Platform.
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" mb={2}>6. Updates</Heading>
              <Text>
                We may update this Cookie Policy to reflect changes in technology or legal requirements. 
                Updated versions will be posted on the platform.
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" mb={2}>7. Contact Us</Heading>
              <Text>
                If you have questions about this Cookie Policy, please contact Measure at:{" "}
                <a href="mailto:Ignite@wemeasure.org" style={{ color: "#3182ce" }}>Ignite@wemeasure.org</a>
              </Text>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="primary" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </IgniteChakraModal>
  );
};

export default CookiePolicyModal;